import { crv, cva } from '@/styled-system/css';

export const paginationItemStyles = cva({
  base: {
    '&:has(>[data-c11n-component="Pagination.PageButton"])': {
      marginInlineStart: 'tightest',
    },
    '&:has(>[data-c11n-component="Pagination.Ellipsis"])': {
      marginInlineStart: 'Pagination.Item.between-pages',
    },
    '[data-c11n-component="Pagination.Item"]:has(>[data-c11n-component="Pagination.PreviousButton"]) + &':
      {
        marginInlineStart: '0',
      },
    '&:has(>[data-c11n-component="Pagination.PreviousButton"])': {
      paddingInline: 'tighter',
      paddingBlock: 'Pagination.JumpItem.padding.vert',
      marginInlineEnd: 'micro.default',
    },
    '&:has(>[data-c11n-component="Pagination.NextButton"])': {
      paddingInline: 'tighter',
      paddingBlock: 'Pagination.JumpItem.padding.vert',
      marginInlineStart: 'micro.default',
    },
    '&:has(>[data-c11n-component="Pagination.JumpToFirstButton"])': {
      paddingInline: 'Pagination.JumpItem.padding.horz',
      paddingBlock: 'Pagination.JumpItem.padding.vert',
    },
    '&:has(>[data-c11n-component="Pagination.JumpToLastButton"])': {
      paddingInline: 'Pagination.JumpItem.padding.horz',
      paddingBlock: 'Pagination.JumpItem.padding.vert',
    },
  },
  variants: {
    ...crv('showNumberButtons', {
      true: {
        '&:has(>[data-c11n-component="Pagination.PageButton"])': {
          display: 'inline-flex',
        },
        '&:has(>[data-c11n-component="Pagination.Ellipsis"])': {
          display: 'inline-flex',
        },
        '&:has(>[data-c11n-component="Pagination.JumpToFirstButton"])': {
          display: 'none',
        },
        '&:has(>[data-c11n-component="Pagination.JumpToLastButton"])': {
          display: 'none',
        },
      },
      false: {
        '&:has(>[data-c11n-component="Pagination.PageButton"])': {
          display: 'none',
        },
        '&:has(>[data-c11n-component="Pagination.Ellipsis"])': {
          display: 'none',
        },
        '&:has(>[data-c11n-component="Pagination.PreviousButton"])': {
          paddingInline: 0,
        },
        '&:has(>[data-c11n-component="Pagination.NextButton"])': {
          paddingInline: 0,
        },
        '&:has(>[data-c11n-component="Pagination.JumpToFirstButton"])': {
          display: 'inline-flex',
          paddingInline: 0,
        },
        '&:has(>[data-c11n-component="Pagination.JumpToLastButton"])': {
          display: 'inline-flex',
          paddingInline: 0,
        },
      },
    }),
  },
});
